import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { MessageData, MessageType } from "Types/api/Messages";
import {
    getMessagesFailure,
    getMessagesRequest,
    getMessagesSuccess,
    postMessageFailure,
    postMessageRequest,
    postMessageSuccess,
} from "src/store/actions/messages";

export interface MessageState {
    loading: boolean;
    data: null | MessageData;
    sending: string[];
    failed: string[];
}

function reducer(
    state: MessageState = {
        loading: false,
        data: null,
        sending: [],
        failed: [],
    },
    action:
        | ActionType<typeof postMessageRequest>
        | ActionType<typeof postMessageSuccess>
        | ActionType<typeof postMessageFailure>
        | ActionType<typeof getMessagesRequest>
        | ActionType<typeof getMessagesSuccess>
        | ActionType<typeof getMessagesFailure>
): MessageState {
    switch (action.type) {
        case postMessageRequest.type:
            return {
                ...state,
                sending: [...state.sending, action.payload.message],
                failed: state.failed.filter((message) => message !== action.payload.message),
            };

        case postMessageSuccess.type:
            return {
                ...state,
                data: {
                    total: (state.data?.total ?? 0) + 1,
                    messages: [
                        {
                            message: action.payload.message,
                            type: MessageType.InAppMessage,
                            displayDate: action.payload.sent,
                            user: null,
                        },
                        ...(state.data?.messages ?? []),
                    ],
                },
                sending: state.sending.filter((message) => message !== action.payload.message),
            };

        case postMessageFailure.type:
            return {
                ...state,
                sending: state.sending.filter((message) => message !== action.payload.message),
                failed: [...state.failed, action.payload.message],
            };

        case getMessagesRequest.type:
            return {
                ...state,
                loading: true,
            };

        case getMessagesSuccess.type:
            return {
                ...state,
                data: action.payload.data,
                loading: false,
            };

        case getMessagesFailure.type:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
}

export default reducer;
